import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  initState,
  selectItemsIds,
  selectItemById,
  selectRequestState,
  selectPagination,
  changeServiceArgs,
  changeQueryParams,
  changeDefaultQueryParams,
  changeStaticQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

import PaginationBlock from '../../../Common/Pagination/PaginationBlock/index';
import MediumPreLoader from '../../../Common/PreLoaders/MediumPreLoader';
import TaskExecLightItem from '../_items/TaskExecLightItem';

class TasksExecsListByTask extends Component {
  constructor(props) {
    super(props);
    this.props.changeDefaultQueryParams({
      page: 1
    });
    this.props.changeServiceArgs([this.props.taskId]);
    this.props.changeStaticQueryParams({
      status: this.props.match.params.execStatus
    });
    this.props.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.execStatus !== this.props.match.params.execStatus
    ) {
      this.props.changeStaticQueryParams({
        status: this.props.match.params.execStatus
      });
      this.props.sendRequest();
    }
  }

  render() {
    let comments = null;
    if (this.props.requestState.inProgress) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            // eslint-disable-next-line react/no-array-index-key
            <TaskExecLightItem
              key={`taskExecLightItem${itemId}`}
              exec={this.props.selectItemById(itemId)}
              reducerName={this.props.listReduceName}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('Выполнения не найдены')} :-(</p>
        </div>
      );
    }

    return <React.Fragment>{comments}</React.Fragment>;
  }
}

TasksExecsListByTask.propTypes = {
  // IN
  taskId: PropTypes.number.isRequired,
  listReduceName: PropTypes.string.isRequired,

  // CONNECT
  sendRequest: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeStaticQueryParams: PropTypes.func.isRequired,
  changeServiceArgs: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      execStatus: PropTypes.string
    })
  }).isRequired
};

TasksExecsListByTask.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id)
});

const mapDispatchToProps = (dispatch, props) => ({
  initState: () => dispatch(initState(props.listReduceName)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeStaticQueryParams: queryParams =>
    dispatch(changeStaticQueryParams(props.listReduceName, queryParams)),
  changeServiceArgs: queryParams =>
    dispatch(changeServiceArgs(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecsListByTask)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/TasksExecsListByTask/TasksExecsListByTask.js